import Request from '@/utils/request'

export function holidayActBaseInfo () {
  return Request({
    url: `/api/v2/app/activity/halloween/home`,
    method: 'get'
  });
}

export function holidayActRank () {
  return Request({
    url: `/api/v2/app/activity/halloween/gift/rank`,
    method: 'get'
  });
}

export function holidayDaySign () {
  return Request({
    url: `/api/v2/app/activity/halloween/daily/sign`,
    method: 'post'
  });
}

export function holidayDayClaim (params) {
  return Request({
    url: `/api/v2/app/activity/halloween/daily/claim`,
    method: 'post',
    params
  });
}